import { NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { IconChevronRightComponent } from "@optee/icons/icon-chevron-right.component";
import { IconComponent } from "@optee/ui/components/icon/icon.component";

@Component({
  selector: "swc-redirect-card",
  template: `
    <div
      class="shadow-o text-primary-900 flex h-72 w-60 cursor-pointer flex-col items-center justify-center gap-12 rounded-2xl bg-white py-11 transition-transform hover:-translate-y-2"
      (click)="onCardClick()"
      [ngClass]="{
        'w-72': type() === 'tendering',
      }"
    >
      <div class="flex flex-col items-center justify-center gap-4">
        <oui-icon
          class="text-primary-500 size-8 xl:size-12"
          [svg]="'bicolor/' + icon()"
        />

        <div
          class="text-center font-semibold leading-relaxed xl:text-2xl"
          [ngClass]="{
            'text-lg font-semibold xl:text-2xl': type() === 'operation',
            'font-bold': type() === 'tendering',
          }"
        >
          {{ name() }}
        </div>
      </div>

      <div class="text-primary-500 flex items-center gap-1">
        <span class="text-sm underline">En savoir plus</span>
        <icon-chevron-right class="size-4" />
      </div>
    </div>
  `,
  imports: [IconChevronRightComponent, IconComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectCardComponent {
  icon = input.required<string>();
  link = input.required<string>();
  name = input.required<string>();
  type = input<"operation" | "tendering">("operation");
  navigate = output<string>();

  onCardClick() {
    this.navigate.emit(this.link());
  }
}
